import { createStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    list: {
      flexGrow: 1,
    },
    sectionDivider: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(0.5),
    },
    sectionHeader: {
      display: 'block',
      padding: theme.spacing(0.5, 2),
      color: theme.palette.grey[500],
      fontSize: '0.65rem',
      fontWeight: 600,
      letterSpacing: '0.08em',
      lineHeight: 1.5,
    },
    listItem: {
      cursor: 'pointer',
      color: theme.palette.grey[700],
      '&:hover': {
        '& $listItemIcon': {
          color: theme.palette.primary.main,
        },
        '& $listItemText': {
          color: theme.palette.primary.main,
        },
      },
      '& + &': {
        marginTop: theme.spacing(1),
      },
    },
    activeListItem: {
      '& $listItemText': {
        color: theme.palette.primary.main,
      },
      '& $listItemIcon': {
        color: theme.palette.primary.main,
      },
    },
    listItemText: {
      fontWeight: 500,
      color: theme.palette.grey[700],
      marginLeft: theme.spacing(1),
      marginTop: 0,
      marginBottom: 0,
    },
    listItemIcon: {
      color: theme.palette.grey[700],
      minWidth: 24,
    },
  });

export default styles;
